









// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'Form'
})
export default class Form extends Vue {
  @Prop({ required: true }) readonly onSubmit!: Function

  submit () {
    // @ts-ignore
    this.$refs.formComponent.submit()
  }
}
